import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { SharedService } from 'src/app/services/shared.service';
import { MainService } from 'src/app/services/main.service';
import { localStorageService } from 'src/app/services/localstorage.service';
import { environment } from 'src/environments/environment';
import { PasswordStrengthService } from 'src/app/services/password-strength.service';

@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrl: './new-password.component.scss'
})
export class NewPasswordComponent implements OnInit {
  public env = environment;
  hideNewPassword: boolean = false;
  hideConfirmPassword: boolean = false;
  newPasswordForm: UntypedFormGroup;
  errorMessage: any;
  validator: number[] = [];
  minLength : boolean = false;
  hasUpperCase: boolean = false;
  hasMaxChar: boolean = false;
  hasNumber : boolean = false;
  hasSpecialChar : boolean = false;
  totalStrength: number = 0;
  ispasswordStrong: boolean =false;
  showPassTooltip  = false;
  passwordStrength: any;
  constructor(private fb: UntypedFormBuilder, private router: Router, private mainService: MainService,
    private _local: localStorageService, private apiSer: ApiService, public _shared: SharedService, public route: ActivatedRoute, private passwordStrengthService: PasswordStrengthService) {
    this.newPasswordForm = this.fb.group({
      newPassword: ["", [Validators.required, ]],
      confirmPassword: ["", Validators.required],
    }, { validator: this.mainService.matchPassword });
  }

  ngOnInit(): void {
    if (!this._local.customGetItem('reset_password_token')) {
      this.mainService.accessTokenLogin();
    }
    this.newPasswordForm.get('newPassword')?.valueChanges.subscribe(password => {
      if ((/[A-Z]/.test(password)) && (/[a-z]/.test(password))) {
        this.hasUpperCase = true;
      }else{
        this.hasUpperCase = false;
      }
      if (/[0-9]/.test(password)) {
        this.hasNumber = true;
      }else{
        this.hasNumber = false;
      }
      if (/[^A-Za-z0-9]/.test(password)) {
        this.hasSpecialChar = true;
      }else{
          this.hasSpecialChar = false;
        }
  
      if (password.length >= 8 ) {
        this.hasMaxChar = true;
      }else{
        this.hasMaxChar = false;
      }
      this.totalStrength = (Number(this.hasUpperCase) + Number(this.hasNumber) + Number(this.hasSpecialChar) + Number(this.hasMaxChar))
      if(this.totalStrength >= 4){
        this.ispasswordStrong = true;
      }else{
        this.ispasswordStrong = false;
      }
        this.passwordStrength = this.passwordStrengthService.calculatePasswordStrength(password);
      });
  }

  submitForm(): void {
    let password = this.newPasswordForm.value.newPassword;
    if (this.newPasswordForm.value.newPassword != this.newPasswordForm.value.confirmPassword) {
      this._shared.customPopups('Passwords did not match', 2);
      return;
    }

    if (this.newPasswordForm.value.newPassword.length < 8) {
      this._shared.customPopups('Passwords must contain at least 8 characters', 2);
      return;
    }

    if (!this.newPasswordForm.value.newPassword || this.newPasswordForm.value.newPassword.trim().length == 0) {
      this._shared.customPopups('Enter a valid password', 2);
      return;
    }
    if (this.newPasswordForm.controls['newPassword'].value.indexOf(' ') >= 0 ){
      this._shared.customPopups('Password cannot contain spaces.', 2);
      return
    }
    if (this.newPasswordForm.value.newPassword.length < 8) {
      this._shared.customPopups('Passwords must contain at least 8 characters', 2);
      return;
    }
    if (!(/[A-Z]/.test(password))) {
      this._shared.customPopups('Please Enter a Strong Password', 2);
      return;
    }
    if (!(/[a-z]/.test(password))) {
      this._shared.customPopups('Please Enter a Strong Password', 2);
      return;
    }
    if (!(/[^A-Za-z0-9]/.test(password))) {
      this._shared.customPopups('Please Enter a Strong Password', 2);
      return;
    }
    if (!(/[0-9]/.test(password))) {
      this._shared.customPopups('Please Enter a Strong Password', 2);
      return;
    }

    let params = {
      reset_password_token: this._local.customGetItem('reset_password_token'),
      doctor_email: this._local.customGetItem('reset_email').replace(/\s/g, '').toLowerCase(),
      doctor_password: this._shared.crypto(this.newPasswordForm.value.newPassword),
      access_token: this._local.customGetItem('token')
    };

    this.apiSer.api(params, "auth/reset_password").subscribe((data: any) => {
      // debugger
      if (data.is_error == 0) {
        this._local.customSetItem('token', data.access_token);
        this._local.customRemoveItem('reset_password_token');
        this._local.customGetItem('reset_email');
        /*setting side menu once user logged in and got side menu data*/
        if (data.menu) {
          this.mainService.checkProfile(data);
        } else {
          this._shared.customPopups(data.original_text || data.err, 1);

        }
        this.mainService.checkProfile(data);
      } else {
        this.newPasswordForm.setErrors({ credentialsMismatch: true });
        this.errorMessage = data.original_text;
      }
      return true;
    })
  }

  routeBack() {
    this._local.customRemoveItem('token')
    this.router.navigate(["/login"]);
  }
}
